module.exports = __webpack_public_path__ + "img/head_3.0cd6dfe7.png";